import { render } from "./AboutSkills.vue?vue&type=template&id=b8983e30&scoped=true"
import script from "./AboutSkills.vue?vue&type=script&lang=js"
export * from "./AboutSkills.vue?vue&type=script&lang=js"

import "./AboutSkills.vue?vue&type=style&index=0&id=b8983e30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8983e30"]])

export default __exports__